const { loadAllowedCatalogRange } = require('./catalogPolicy');

const reloadBoard = async ({ transport, action, active, range }) => {
    if (!active()) return;
    await transport.dispatch({ action: 'Unload' }, 'board');
    // Once reset starts, restore the model even if the tab becomes hidden.
    await transport.dispatch(action, 'board');
    if (!active() || !range) return;
    const next = await transport.getState('board');
    if (!active()) return;
    const requests = [];
    loadAllowedCatalogRange(next.catalogs, range, (args) => {
        requests.push(transport.dispatch({ action: 'CatalogsWithExtra', args: { action: 'LoadRange', args } }, 'board'));
    });
    await Promise.all(requests);
};

module.exports = reloadBoard;
